import React from 'react';
import './DeshOrder.css'
import { useOrderCount } from './../../Global/allglobal'


const DeshOrder = () => {
    const  count  = useOrderCount()

    return (
        <div>
            <div className='D-O-Container'>
                <div>
                    <p>Pending Order</p>
                    <h1>{count}</h1>
                </div>
                <div>
                    <p>Running Order</p>
                    <h1>00</h1>
                </div>
                <div>
                    <p>Cancel Order</p>
                    <h1>00</h1>
                </div>
            </div>

            <section>
                <p>order increment graphs</p>
            </section>
        </div>
    );
};

export default DeshOrder;